<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre13" id="pgepubid00030"><a class="calibre1" id="page16"></a><span class="calibre1" id="pgepubid00031" title="p. 16"></span>THE
ROYAL SPORT NAUTIQUE</h2>
<p class="calibre7"><span class="smcap">The</span> rain took off near
Laeken.  But the sun was already down; the air was chill;
and we had scarcely a dry stitch between the pair of us. 
Nay, now we found ourselves near the end of the Allée
Verte, and on the very threshold of Brussels, we were confronted
by a serious difficulty.  The shores were closely lined by
canal boats waiting their turn at the lock.  Nowhere was
there any convenient landing-place; nowhere so much as a
stable-yard to leave the canoes in for the night.  We
scrambled ashore and entered an <i class="calibre22">estaminet</i> where some sorry
fellows were drinking with the landlord.  The landlord was
pretty round with us; he knew of no coach-house or stable-yard,
nothing of the sort; and seeing we had come with no mind to
drink, he did not conceal his impatience to be rid of us. 
One of the sorry fellows came to the rescue.  Somewhere in
the corner of the basin there was a slip, he informed us, and
something else besides, not very clearly defined by him, but
hopefully construed by his hearers.</p>
<p class="calibre7">Sure enough there was the slip in the corner of the basin; and
at the top of it two nice-looking lads in boating clothes. 
The <i class="calibre22">Arethusa</i> addressed himself to these.  One of them
said there would be no difficulty about a night’s lodging
for our boats; and the other, taking a cigarette from his lips,
inquired if they were made by Searle and Son.  The name was
quite an introduction.  Half-a-dozen other young men came
out of a boat-house bearing the superscription <span class="smcap">Royal Sport Nautique</span>, and joined in the
talk.  They were all very polite, voluble, and enthusiastic;
and their discourse was interlarded with English boating terms,
and the names of English boat-builders and English clubs.  I
do not know, to my shame, any spot in my native land where I
should have been so warmly received by the same number of
people.  We were English boating-men, and the Belgian
boating-men fell upon our necks.  I wonder if French
Huguenots were as cordially greeted by English Protestants when
they came across the Channel out of great tribulation.  But
after all, what religion knits people so closely as a common
sport?</p>
<p class="calibre7">The canoes were carried into the boat-house; they were washed
down for us by the Club servants, the sails were hung out to dry,
and everything made as snug and tidy as a picture.  And in
the meanwhile we were led upstairs by our new-found brethren, for
so more than one of them stated the relationship, and made free
of their lavatory.  This one lent us soap, that one a towel,
a third and fourth helped us to undo our bags.  And all the
time such questions, such assurances of respect and
sympathy!  I declare I never knew what glory was before.</p>
<p class="calibre7">‘Yes, yes, the <i class="calibre22">Royal Sport Nautique</i> is the oldest
club in Belgium.’</p>
<p class="calibre7">‘We number two hundred.’</p>
<p class="calibre7">‘We’—this is not a substantive speech, but
an abstract of many speeches, the impression left upon my mind
after a great deal of talk; and very youthful, pleasant, natural,
and patriotic it seems to me to be—‘We have gained
all races, except those where we were cheated by the
French.’</p>
<p class="calibre7">‘You must leave all your wet things to be
dried.’</p>
<p class="calibre7">‘O! <i class="calibre22">entre frères</i>!  In any boat-house
in England we should find the same.’  (I cordially
hope they might.)</p>
<p class="calibre7">‘<i class="calibre22">En Angleterre</i>, <i class="calibre22">vous employez des
sliding-seats</i>, <i class="calibre22">n’est-ce pas</i>?’</p>
<p class="calibre7">‘We are all employed in commerce during the day; but in
the evening, <i class="calibre22">voyez-vous</i>, <i class="calibre22">nous sommes
sérieux</i>.’</p>
<p class="calibre7">These were the words.  They were all employed over the
frivolous mercantile concerns of Belgium during the day; but in
the evening they found some hours for the serious concerns of
life.  I may have a wrong idea of wisdom, but I think that
was a very wise remark.  People connected with literature
and philosophy are busy all their days in getting rid of
second-hand notions and false standards.  It is their
profession, in the sweat of their brows, by dogged thinking, to
recover their old fresh view of life, and distinguish what they
really and originally like, from what they have only learned to
tolerate perforce.  And these Royal Nautical Sportsmen had
the distinction still quite legible in their hearts.  They
had still those clean perceptions of what is nice and nasty, what
is interesting and what is dull, which envious old gentlemen
refer to as illusions.  The nightmare illusion of middle
age, the bear’s hug of custom gradually squeezing the life
out of a man’s soul, had not yet begun for these
happy-starred young Belgians.  They still knew that the
interest they took in their business was a trifling affair
compared to their spontaneous, long-suffering affection for
nautical sports.  To know what you prefer, instead of humbly
saying Amen to what the world tells you you ought to prefer, is
to have kept your soul alive.  Such a man may be generous;
he may be honest in something more than the commercial sense; he
may love his friends with an elective, personal sympathy, and not
accept them as an adjunct of the station to which he has been
called.  He may be a man, in short, acting on his own
instincts, keeping in his own shape that God made him in; and not
a mere crank in the social engine-house, welded on principles
that he does not understand, and for purposes that he does not
care for.</p>
<p class="calibre7">For will any one dare to tell me that business is more
entertaining than fooling among boats?  He must have never
seen a boat, or never seen an office, who says so.  And for
certain the one is a great deal better for the health. 
There should be nothing so much a man’s business as his
amusements.  Nothing but money-grubbing can be put forward
to the contrary; no one but</p>
<blockquote class="calibre11"><div class="container"><p class="calibre7">Mammon, the least erected spirit that fell<br class="calibre5"/>
From Heaven,</p>
</div>
</blockquote>
<p class="calibre7">durst risk a word in answer.  It is but a lying cant that
would represent the merchant and the banker as people
disinterestedly toiling for mankind, and then most useful when
they are most absorbed in their transactions; for the man is more
important than his services.  And when my Royal Nautical
Sportsman shall have so far fallen from his hopeful youth that he
cannot pluck up an enthusiasm over anything but his ledger, I
venture to doubt whether he will be near so nice a fellow, and
whether he would welcome, with so good a grace, a couple of
drenched Englishmen paddling into Brussels in the dusk.</p>
<p class="calibre7">When we had changed our wet clothes and drunk a glass of pale
ale to the Club’s prosperity, one of their number escorted
us to an hotel.  He would not join us at our dinner, but he
had no objection to a glass of wine.  Enthusiasm is very
wearing; and I begin to understand why prophets were unpopular in
Judæa, where they were best known.  For three stricken
hours did this excellent young man sit beside us to dilate on
boats and boat-races; and before he left, he was kind enough to
order our bedroom candles.</p>
<p class="calibre7">We endeavoured now and again to change the subject; but the
diversion did not last a moment: the Royal Nautical Sportsman
bridled, shied, answered the question, and then breasted once
more into the swelling tide of his subject.  I call it his
subject; but I think it was he who was subjected.  The
<i class="calibre22">Arethusa</i>, who holds all racing as a creature of the devil,
found himself in a pitiful dilemma.  He durst not own his
ignorance for the honour of Old England, and spoke away about
English clubs and English oarsmen whose fame had never before
come to his ears.  Several times, and, once above all, on
the question of sliding-seats, he was within an ace of
exposure.  As for the <i class="calibre22">Cigarette</i>, who has rowed races
in the heat of his blood, but now disowns these slips of his
wanton youth, his case was still more desperate; for the Royal
Nautical proposed that he should take an oar in one of their
eights on the morrow, to compare the English with the Belgian
stroke.  I could see my friend perspiring in his chair
whenever that particular topic came up.  And there was yet
another proposal which had the same effect on both of us. 
It appeared that the champion canoeist of Europe (as well as most
other champions) was a Royal Nautical Sportsman.  And if we
would only wait until the Sunday, this infernal paddler would be
so condescending as to accompany us on our next stage. 
Neither of us had the least desire to drive the coursers of the
sun against Apollo.</p>
<p class="calibre7">When the young man was gone, we countermanded our candles, and
ordered some brandy and water.  The great billows had gone
over our head.  The Royal Nautical Sportsmen were as nice
young fellows as a man would wish to see, but they were a trifle
too young and a thought too nautical for us.  We began to
see that we were old and cynical; we liked ease and the agreeable
rambling of the human mind about this and the other subject; we
did not want to disgrace our native land by messing an eight, or
toiling pitifully in the wake of the champion canoeist.  In
short, we had recourse to flight.  It seemed ungrateful, but
we tried to make that good on a card loaded with sincere
compliments.  And indeed it was no time for scruples; we
seemed to feel the hot breath of the champion on our necks.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?c8dc0baa